import React, { createContext, useContext, useState, ReactNode } from 'react';
// Components
import { TipsDrawer } from 'app/components/TipsDrawer';

const TipsContext = createContext<{ showTip: (key: string) => void }>({ showTip: () => {} });

export const TipsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [tipKey, setTipKey] = useState<string | null>(null);

  const showTip = (key: string) => setTipKey(key);
  const handleClose = () => setTipKey(null);

  return (
    <TipsContext.Provider value={{ showTip }}>
      {children}
      <TipsDrawer tipKey={tipKey as any} open={!!tipKey} onClose={handleClose} />
    </TipsContext.Provider>
  );
};

export const useTips = () => useContext(TipsContext);
